<template>
  <div class="grouplist">
    <div class="noOrders" v-if="grouplist.length == 0">
      <div v-if="!firstLoading">你还没有商品哦...</div>
      <van-loading v-else type="spinner" />
    </div>
    <div v-if="grouplist.length > 0" class="scroll">
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        style="height: calc(100% - 24.2vw); overflow: auto"
      >
        <van-list v-model="loading" :finished="finished" finished-text="到底啦~" @load="onLoad">
          <van-grid :column-num="2" gutter="3vw" class="goods-grid">
            <van-grid-item
              @click="onGoodsClick(goods)"
              v-for="goods in grouplist"
              :key="goods.code"
            >
              <div class="image">
                <van-image :src="goods.imageUrl" />
              </div>
              <div class="text">
                <div class="goodsName">{{ goods.goodsName }}</div>
                <div class="price">￥{{ goods.goodsPrice }}</div>
              </div>
            </van-grid-item>
          </van-grid>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import { Image, Grid, GridItem, List, PullRefresh } from "vant";
import service from "../../api/group/index";
export default {
  components: {
    [Image.name]: Image,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      showEmpty: false,
      grouplist: [],
      groupChildlist: [],
      activeId: 1,
      activeIndex: 0,
      loading: false,
      finished: false,
      refreshing: false,
      firstLoading:false,
      page: 1,
      pageSize: 10
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getList().then(grouplist => {
        this.grouplist = this.grouplist.concat(grouplist);
        this.loading = false;
        if (grouplist.length < 10) {
          this.finished = true;
        }
      });
    },
    onLoad() {
      this.page++;
      this.getList().then(grouplist => {
        this.grouplist = this.grouplist.concat(grouplist);
        this.loading = false;
        if (grouplist.length < 10) {
          this.finished = true;
        }
      });
    },
    onRefresh() {
      // 清空列表数据
      this.page = 1;
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.grouplist = [];
      this.getList().then(grouplist => {
        this.grouplist = grouplist;
        if (grouplist.length < 10) {
          this.finished = true;
          this.loading = false;
        }
        //
        this.refreshing = true;
        this.onLoad();
      });
    },
    getList() {
      return new Promise((resolve, reject) => {
        service
          .getChildItems(this.$route.query.id,this.$route.query.code, this.page, this.pageSize)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            // reject();
          });
      });
    },
    onGoodsClick(goods) {
      this.$router.push({ name: "goods", query: { code: goods.goodsCode } });
    }
  }
};
</script>
<style lang="less" scoped>
@deep: ~">>>";
.grouplist {
  padding: 3vw 0;
}
.image {
  height: 150px;
  .van-image {
    height: 150px;
    @{deep} .van-image__img {
      border-radius: 12px 12px 0 0;
      width: 100%;
      height: 100%;
    }
  }
}

@{deep} [class*="van-hairline"]::after {
  border: none;
}
</style>